// Mock data for Mind Motion Physiotherapy website

export const clinicInfo = {
  name: "Mind Motion Physiotherapy and Rehab Centre",
  tagline: "Pain → Recovery → Movement",
  description: "Personalised physiotherapy. Evidence-led. Local to Bellandur.",
  phone: "+91 90085 41255",
  whatsapp: "+91 90085 41255",
  email: "mindmotionphysiotherapy@gmail.com",
  locations: [
    {
      id: 1,
      name: "Bellandur Clinic",
      address: "opposite to vyapar exit gate, 10/2a, Bellandur gate, Sarjapur road, Bellandur, Bangalore - 560103",
      landmark: "",
      mapLink: "https://maps.google.com/?q=Mind+Motion+Physiotherapy+and+Rehab+Centre+opposite+to+vyapar+exit+gate+10/2a+Bellandur+gate+Sarjapur+road+Bellandur+Bangalore+560103",
      hours: "Mon-Sat: 9:00 AM - 8:30 PM, Sun: 10:30 AM - 2:00 PM"
    }
  ]
};

// Hero carousel slides with Indian client personas
export const heroSlides = [
  {
    id: 1,
    image: "/images/Hero4.jpg",
    title: "Pain → Recovery → Movement",
    subtitle: "Expert care for IT professionals with desk-related pain"
  },
  {
    id: 2,
    image: "/images/Hero2.jpg",
    title: "Pain → Recovery → Movement",
    subtitle: "Specialized care for young professionals returning to active life"
  },
  {
    id: 3,
    image: "/images/Hero3.jpg",
    title: "Pain → Recovery → Movement",
    subtitle: "Personalized treatment for homemakers with daily activity pain"
  },
  {
    id: 4,
    image: "/images/Hero1.jpg",
    title: "Pain → Recovery → Movement",
    subtitle: "Expert rehabilitation for experienced professionals"
  }
];

// Real clinic images
export const clinicImages = {
  equipment: "/images/wmm1.jpg",
  treatmentRoom1: "/images/wmm2.jpg",
  facility: "/images/wmm3.jpg",
  treatmentRoom2: "/images/wmm4.jpg",
  exerciseArea: "/images/wmm5.jpg"
};

export const drRupesh = {
  name: "Dr. Rupesh Kumar",
  qualification: "BPT, MPT (neurology), Certified Manual Therapist",
  experience: "4+ years",
  specialization: "Adult Neurology",
  philosophy: "I believe in treating the root cause, not just the symptoms. Every patient deserves a personalized recovery plan that respects their lifestyle, goals, and pace of healing.",
  image: "/images/wmm6.jpeg"
};

export const whyMindMotion = [
  {
    id: 1,
    title: "Clinical Expertise",
    description: "Evidence based protocols backed by 5+ years of spinal and postural health, advance orthopedic, neurological recovery, Athlete performance and geriatric care",
    icon: "Award"
  },
  {
    id: 2,
    title: "Hands-On Care",
    description: "One-on-one sessions with personalized treatment plans, not generic exercise sheets",
    icon: "Hand"
  },
  {
    id: 3,
    title: "Proven Outcomes",
    description: "Track record of helping patients return to pain-free movement and active lifestyles",
    icon: "TrendingUp"
  },
  {
    id: 4,
    title: "HTP - Tailored made Home training program",
    description: "Tailored made Home training program for each patient to ensure recovery",
    icon: "CheckCircle"
  }
];

// Helpful Resources - Home Treatment Plans
export const helpfulResources = [
  {
    id: 1,
    title: "IT Professional's Recovery Guide",
    description: "Head, neck, and shoulder strengthening exercises for desk workers",
    category: "Occupational Health",
    downloadLink: "/docs/neck stretches.pdf",
    icon: "Laptop"
  },
  {
    id: 2,
    title: "Neck & Shoulder Care",
    description: "Targeted exercises for tech neck and shoulder tension",
    category: "Upper Body",
    downloadLink: "/docs/neck stretches.pdf",
    icon: "User"
  },
  {
    id: 3,
    title: "Back Pain Relief Program",
    description: "Comprehensive exercises for lower back pain management",
    category: "Pain Management",
    downloadLink: "/docs/LOW BACK PAIN stretches.pdf",
    icon: "Move"
  },
  {
    id: 4,
    title: "Knee Strengthening Routine",
    description: "Progressive exercises for knee stability and pain relief",
    category: "Lower Body",
    downloadLink: "/docs/Knee Basic Exercises.pdf",
    icon: "Activity"
  },
  {
    id: 5,
    title: "Homemaker's Wellness Plan",
    description: "Daily exercises for managing household activity-related pain",
    category: "Daily Living",
    downloadLink: "/docs/Upper back stretches.pdf",
    icon: "Home"
  },
  {
    id: 6,
    title: "50+ Active Living Guide",
    description: "Age-appropriate exercises for maintaining mobility and strength",
    category: "Senior Wellness",
    downloadLink: "/docs/basic low back strengthening exercise.pdf",
    icon: "Heart"
  },
  {
    id: 7,
    title: "Post-Surgery Recovery",
    description: "Guided rehabilitation exercises for post-operative care",
    category: "Rehabilitation",
    downloadLink: "/docs/basic low back strengthening exercise.pdf",
    icon: "Stethoscope"
  },
  {
    id: 8,
    title: "Sports Injury Prevention",
    description: "Warm-up and strengthening routines for athletes",
    category: "Sports Health",
    downloadLink: "/docs/Knee Basic Exercises.pdf",
    icon: "Zap"
  }
];

export const conditions = [
  {
    id: 1,
    name: "Neck Pain & Stiffness",
    shortDesc: "Cervical spondylosis, tech neck, postural issues",
    category: "everyday",
    categoryName: "Everyday Conditions",
    icon: "User",
    image: "/images/TP_neck_pain.jpeg",
    bodyPart: "neck"
  },
  {
    id: 2,
    name: "Upper Back Pain",
    shortDesc: "Postural pain, muscle tension, thoracic spine issues",
    category: "everyday",
    categoryName: "Everyday Conditions",
    icon: "Move",
    image: "/images/TP_upperback_pain.jpeg",
    bodyPart: "upper-back"
  },
  {
    id: 3,
    name: "Lower Back Pain",
    shortDesc: "Chronic back pain, sciatica, disc problems, lumbar issues",
    category: "everyday",
    categoryName: "Everyday Conditions",
    icon: "Move",
    image: "/images/TP_lower_back_Pain.jpeg",
    bodyPart: "lower-back"
  },
  {
    id: 4,
    name: "Shoulder Pain",
    shortDesc: "Frozen shoulder, rotator cuff injuries, impingement",
    category: "everyday",
    categoryName: "Everyday Conditions",
    icon: "User",
    image: "/images/TP_shoulder_pain.jpeg",
    bodyPart: "shoulder"
  },
  {
    id: 5,
    name: "Knee Pain",
    shortDesc: "Osteoarthritis, ligament injuries, post-surgical rehabilitation",
    category: "everyday",
    categoryName: "Everyday Conditions",
    icon: "CircleDot",
    image: "/images/TP_knee_pain.jpeg",
    bodyPart: "knee"
  },
  {
    id: 6,
    name: "Ankle Pain",
    shortDesc: "Sprains, instability, post-injury rehabilitation",
    category: "everyday",
    categoryName: "Everyday Conditions",
    icon: "Activity",
    image: "/images/TP_ankle_pain.jpeg",
    bodyPart: "ankle"
  },
  {
    id: 7,
    name: "Sports Injuries",
    shortDesc: "ACL tears, sprains, muscle strains, athletic performance recovery",
    category: "sports",
    categoryName: "Sports Rehabilitation",
    icon: "Activity",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&q=80",
    bodyPart: "full-body"
  },
  {
    id: 8,
    name: "Neurological Conditions",
    shortDesc: "Stroke recovery, nerve injuries, balance issues",
    category: "specific",
    categoryName: "Specific Conditions",
    icon: "Brain",
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=600&q=80",
    bodyPart: "neurological"
  },
  {
    id: 9,
    name: "Post-Operative Care",
    shortDesc: "Joint replacements, fracture recovery, surgical rehabilitation",
    category: "specific",
    categoryName: "Specific Conditions",
    icon: "Stethoscope",
    image: "https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=600&q=80",
    bodyPart: "post-op"
  },
  {
    id: 10,
    name: "Work-Related Injuries",
    shortDesc: "Repetitive strain, carpal tunnel, desk posture correction",
    category: "everyday",
    categoryName: "Everyday Conditions",
    icon: "Briefcase",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&q=80",
    bodyPart: "upper-body"
  }
];

export const treatmentDetails = {
  1: {
    name: "Back Pain & Spine Issues",
    painPoints: [
      "Persistent lower back pain affecting daily activities",
      "Sciatica radiating down the leg",
      "Difficulty sitting or standing for long periods",
      "Morning stiffness and reduced mobility"
    ],
    approach: "We use a combination of manual therapy, core strengthening, and postural correction to address the root cause of your spine issues. Our evidence-based protocols focus on long-term relief, not temporary fixes.",
    recoveryPath: [
      { phase: "Week 1-2", focus: "Pain relief and mobility restoration" },
      { phase: "Week 3-4", focus: "Core strengthening and stability" },
      { phase: "Week 5-8", focus: "Functional movement and prevention" }
    ],
    outcomes: "85% of our back pain patients report significant improvement within 6-8 weeks"
  },
  2: {
    name: "Sports Injuries",
    painPoints: [
      "Sudden injury during sports or exercise",
      "Recurring pain limiting athletic performance",
      "Post-surgery return to sport concerns",
      "Loss of strength and mobility"
    ],
    approach: "Sport-specific rehabilitation that gets you back to your game stronger. We combine therapeutic exercises, manual therapy, and progressive loading protocols tailored to your sport.",
    recoveryPath: [
      { phase: "Week 1-3", focus: "Healing and pain management" },
      { phase: "Week 4-6", focus: "Strength and range of motion" },
      { phase: "Week 7-12", focus: "Sport-specific training and prevention" }
    ],
    outcomes: "Athletes return to their sport with reduced re-injury risk and improved performance"
  },
  3: {
    name: "Knee Pain",
    painPoints: [
      "Pain while climbing stairs or walking",
      "Swelling and stiffness in the knee joint",
      "Difficulty kneeling or squatting",
      "Instability or giving way sensation"
    ],
    approach: "Comprehensive knee rehabilitation focusing on strengthening surrounding muscles, improving joint mechanics, and restoring pain-free movement patterns.",
    recoveryPath: [
      { phase: "Week 1-2", focus: "Reduce inflammation and pain" },
      { phase: "Week 3-6", focus: "Strengthen quadriceps and hamstrings" },
      { phase: "Week 7-10", focus: "Functional activities and stability" }
    ],
    outcomes: "Patients experience improved mobility and return to daily activities without pain"
  }
};

export const howItWorks = [
  {
    step: 1,
    title: "Detailed evaluation of your condition, movement patterns, and lifestyle factors",
    description: "Comprehensive Assessment",
    icon: "ClipboardList"
  },
  {
    step: 2,
    title: "Evidence-based protocol tailored to your specific needs and recovery goals",
    description: "Personalised Treatment Plan",
    icon: "FileText"
  },
  {
    step: 3,
    title: "One-on-one therapy with hands-on techniques and progressive exercises",
    description: "Guided Recovery Sessions",
    icon: "Users"
  },
  {
    step: 4,
    title: "Return to pain-free daily activities with strategies to prevent recurrence",
    description: "Back to Movement",
    icon: "CheckCircle"
  }
];

export const testimonials = [
  {
    "id": 1,
    "name": "Sayan Dutta",
    "condition": "Post surgery wrist fracture",
    "text": "Great experience. I had fractured my wrist and post surgery I had very low strength and mobility. After taking regular sessions with Dr. Rupesh and Dr. Riya, my wrist is completely back to normalcy in terms of strength and movement within 15 days. They are very attentive and gives full attention to you during every session. They are very knowledgable and experienced to handle complex cases such as mine (I had multiple fracture and permament plate installed in my wrist). Highly recommended.",
    "rating": 5,
    "location": "Bellandur - Golden Corner"
  },
  {
    "id": 2,
    "name": "Lavanya M",
    "condition": "Patella Dislocation",
    "text": "I recently completed 8 weeks of physiotherapy at Mind Motion Physiotherapy after suffering a knee dislocation, and I'm extremely happy with the results. The treatment plan was well-structured and tailored specifically to my condition. They also provided a detailed home training program that really supported my recovery. During each session, Dr. Riya carefully monitored my exercises, corrected my posture and positioning, and regularly assessed my progress. Her guidance, professionalism, and encouragement made a big difference in my recovery journey. After 8 weeks, I feel much more confident in my knee stability and strength, and I haven't experienced any further dislocation issues. I highly recommend Mind Motion Physiotherapy to anyone looking for personalized and effective rehabilitation care. Thanks to Dr. Rupesh and Dr. Riya",
    "rating": 5,
    "location": "Whitefield"
  },
  {
    "id": 3,
    "name": "Vaibhav Goel",
    "condition": "Left IT band syndrome + Shin Splint",
    "text": "I was very demotivated and sad when my knee pain completely restricted me from running. I lost few planned marathons due to my runner's knee issue. And that's when I got to know about Mind Motion. Dr Rupesh and his team worked on my situation. And in just 4 sessions I was back on road with my laces on... what really helped me is Dr Rupesh's accurate diagnosis, building a focused plan to recover, dedicatedly worked on my pain, muscles flexibility to adjust sessions timing based on my busy schedule, even helped me with recommending a detailed plan that I could practice at home. If you are in physical pain then please don't ignore and don't wait. Highly recommend to connect with mind motion and Dr Rupesh.",
    "rating": 5,
    "location": "Sarjapur - Springfield Appartment"
  },
  {
    "id": 5,
    "name": "Aditya Bhandari",
    "condition": "Lt lateral collateral ligament sprain + Bilateral bicipital tendinitis",
    "text": "Came to the clinic when I experienced knee pain during my half marathon training. Dr Rupesh and team did a wonderful job with an initial diagnosis and helped come up with a proper plan with gradually ramping up the excercises (strengthening and stability) which helped me be ready just in time and complete the race without any issues. Super thankful to the team and would 100% recommend.",
    "rating": 5,
    "location": "Bellandur - Krystal Appartment : Amazon"
  },
  {
    "id": 6,
    "name": "Lekshmi I",
    "condition": "Right medial Hamstring tendon tear",
    "text": "I had an excellent experience with Dr.Rupesh. He is professional, attentive, and genuinely cared about my recovery. Each session was well-structured, and he explained the exercises clearly, making sure I understood the purpose behind them. His treatment helped me improve significantly, and I always felt comfortable and supported throughout the process. I truly appreciate his dedication and expertise, and I would highly recommend him to anyone seeking quality physiotherapy care",
    "rating": 5,
    "location": "Bellandur - The Central Regency Address"
  },
  {
    "id": 7,
    "name": "Rushabh Lalwani",
    "condition": "Left Trapezitis + Cervical C2-C3 level disc bulge",
    "text": "Dr. Rupesh and Dr. Riya were super helpful and supportive for my neck injury. They clarified every doubt and concern I had over my injury. And gently helped me recover.",
    "rating": 5,
    "location": "Bellandur - Google"
  },
  {
    "id": 8,
    "name": "Nidhi Sen",
    "condition": "Mechanical Neck Pain",
    "text": "I had mechanical neck pain, and it was very difficult for me to rotate my neck and shoulder. Dr. Riya and Dr. Rupesh provided highly effective treatment, and within just a few days, I was able to move my neck much more comfortably. They also gave me dedicated exercises and were incredibly supportive and cooperative throughout all the sessions. I truly appreciate their professionalism, attention to details, and caring approach. The clinic maintains a positive environment that motivates recovery. I would highly recommend this center to anyone seeking quality physiotherapy care.",
    "rating": 5,
    "location": "Bellandur - Golden Corner"
  },
  {
    "id": 9,
    "name": "Naman Samarth",
    "condition": "Right shoulder impingement",
    "text": "Shoulder impingement treatment. Clear explanations, patient guidance. Exercises that actually helped. Noticeable pain relief and better mobility. Overall very good experience.",
    "rating": 5,
    "location": "Bellandur - PhonePe"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How long is each session?",
    answer: "Each one-on-one session typically lasts 45-60 minutes, allowing adequate time for manual therapy, guided exercises, and personalized attention."
  },
  {
    id: 2,
    question: "How many sessions will I need?",
    answer: "It varies based on your condition. Acute issues may resolve in 4-6 sessions, while chronic conditions might need 8-12 sessions. We'll provide a clear timeline after your initial assessment."
  },
  {
    id: 3,
    question: "Do you accept insurance?",
    answer: "Yes, we provide detailed invoices that you can submit to your insurance provider for reimbursement. We work with most major insurance companies."
  },
  {
    id: 4,
    question: "What should I bring to my first appointment?",
    answer: "Please bring any recent medical reports, imaging results (X-rays, MRI), and wear comfortable clothing that allows easy movement."
  },
  {
    id: 5,
    question: "Do you treat sports injuries?",
    answer: "Absolutely. We specialize in sports rehabilitation and work with athletes of all levels to ensure safe return to sport with reduced injury risk."
  }
];
